<div class="auth-layout">
  <div class="auth-layout__logo-row">
    <img
      class="auth-layout__logo-icon"
      src="assets/plan/Happy-Plan-Doodat.png"
      alt=""
      aria-hidden="true"
    />
    <img class="auth-layout__logo-wordmark" src="assets/logo/logo-flip-text.svg" alt="flip*" />
  </div>

  <div class="auth-layout__panel" [class.auth-layout__panel--plain]="!panelBackground">
    <ng-content></ng-content>
  </div>

  <picture class="auth-layout__hero">
    <source
      srcset="assets/account/registration-hero-desktop-tablet.png"
      media="(min-width: 400px)"
    />
    <img src="assets/account/registration-hero-mobile.png" alt="" aria-hidden="true" />
  </picture>
</div>
